<p-toast></p-toast>

<div class="analytics-dashboard">
  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-spinner">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Cargando datos...</span>
    </div>
  </div>

  <!-- Header -->
  <div class="dashboard-header">
    <div class="header-title">
      <h2><i class="ri-bar-chart-box-line"></i> Dashboard de Analítica</h2>
      <p class="subtitle">
        Datos reales: participantes, mensajes, campañas y programas
      </p>
    </div>
    <div class="header-actions">
      <button
        pButton
        icon="pi pi-download"
        label="Exportar CSV"
        class="p-button-sm p-button-outlined p-button-success"
        (click)="exportCSV()"
        [disabled]="!campaignData.length"
      ></button>
      <button
        pButton
        icon="pi pi-refresh"
        label="Actualizar"
        class="p-button-sm p-button-outlined"
        (click)="loadAll()"
        [loading]="loading"
      ></button>
    </div>
  </div>

  <!-- Filters Bar -->
  <div class="filters-bar">
    <div class="filters-row">
      <div class="filter-item">
        <mat-form-field appearance="outline">
          <mat-label>Línea</mat-label>
          <mat-select
            [(ngModel)]="selectedLine"
            (ngModelChange)="onLineChange()"
          >
            <mat-option [value]="null">Todas las líneas</mat-option>
            <mat-option *ngFor="let l of lines" [value]="l.id">{{
              l.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-item">
        <mat-form-field appearance="outline">
          <mat-label>Grupo</mat-label>
          <mat-select
            [(ngModel)]="selectedGroup"
            (ngModelChange)="applyFilters()"
          >
            <mat-option [value]="null">Todos los grupos</mat-option>
            <mat-option *ngFor="let g of groups" [value]="g.id">{{
              g.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-item">
        <mat-form-field appearance="outline">
          <mat-label>Granularidad</mat-label>
          <mat-select
            [(ngModel)]="selectedGranularity"
            (ngModelChange)="applyFilters()"
          >
            <mat-option
              *ngFor="let opt of granularityOptions"
              [value]="opt.value"
              >{{ opt.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-item filter-item--date">
        <mat-form-field appearance="outline">
          <mat-label>Rango de fechas</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="dateFrom" placeholder="Desde" />
            <input
              matEndDate
              [(ngModel)]="dateTo"
              placeholder="Hasta"
              (dateChange)="onDateRangeChange()"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="filter-actions">
        <button mat-stroked-button color="warn" (click)="clearFilters()">
          <mat-icon>filter_list_off</mat-icon>
          Limpiar
        </button>
      </div>
    </div>
  </div>

  <!-- KPI Cards -->
  <div class="kpi-grid" *ngIf="overview">
    <div class="kpi-card kpi-card--blue">
      <div class="kpi-icon"><i class="ri-group-line"></i></div>
      <div class="kpi-content">
        <span class="kpi-value">{{ overview.totalParticipants | number }}</span>
        <span class="kpi-label">Total Participantes</span>
      </div>
    </div>
    <div class="kpi-card kpi-card--green">
      <div class="kpi-icon"><i class="ri-user-follow-line"></i></div>
      <div class="kpi-content">
        <span class="kpi-value">{{
          overview.registeredParticipants | number
        }}</span>
        <span class="kpi-label">Registrados</span>
        <span class="kpi-sub">{{ overview.registrationRate }}% del total</span>
      </div>
    </div>
    <div class="kpi-card kpi-card--indigo">
      <div class="kpi-icon"><i class="ri-chat-3-line"></i></div>
      <div class="kpi-content">
        <span class="kpi-value">{{ overview.totalMessages | number }}</span>
        <span class="kpi-label">Total Mensajes</span>
        <span class="kpi-sub"
          >{{ overview.botMessages | number }} bot ·
          {{ overview.userMessages | number }} usuarios</span
        >
      </div>
    </div>
    <div class="kpi-card kpi-card--orange">
      <div class="kpi-icon"><i class="ri-megaphone-line"></i></div>
      <div class="kpi-content">
        <span class="kpi-value">{{ overview.activeCampaigns | number }}</span>
        <span class="kpi-label">Campañas Activas</span>
      </div>
    </div>
    <div class="kpi-card kpi-card--teal">
      <div class="kpi-icon"><i class="ri-book-open-line"></i></div>
      <div class="kpi-content">
        <span class="kpi-value">{{ overview.totalPrograms | number }}</span>
        <span class="kpi-label">Total Programas</span>
        <span class="kpi-sub"
          >{{ overview.activePrograms | number }} activos</span
        >
      </div>
    </div>
    <div class="kpi-card kpi-card--pink">
      <div class="kpi-icon"><i class="ri-percent-line"></i></div>
      <div class="kpi-content">
        <span class="kpi-value">{{ overview.registrationRate }}%</span>
        <span class="kpi-label">Tasa de Registro</span>
        <span class="kpi-sub"
          >{{ overview.unregisteredParticipants | number }} sin registrar</span
        >
      </div>
    </div>
  </div>

  <!-- Row 1: Gender Donut + Bar chart (line / group) -->
  <div class="charts-row">
    <div class="chart-card chart-card--third">
      <div class="chart-header">
        <h3><i class="ri-pie-chart-2-line"></i> Distribución por Género</h3>
      </div>
      <div class="chart-body">
        <app-funnel-chart [genderData]="genderData"></app-funnel-chart>
      </div>
    </div>
    <div class="chart-card chart-card--twothirds">
      <div class="chart-header">
        <h3>
          <i class="ri-bar-chart-grouped-line"></i> Participantes por Línea y
          Grupo
        </h3>
      </div>
      <div class="chart-body">
        <app-stats-breakdown
          [lineData]="lineData"
          [groupData]="groupData"
        ></app-stats-breakdown>
      </div>
    </div>
  </div>

  <!-- Row 2: Timeline Chart (full width) -->
  <div class="charts-row">
    <div class="chart-card chart-card--full">
      <div class="chart-header">
        <h3><i class="ri-line-chart-line"></i> Actividad en el Tiempo</h3>
        <span class="chart-subtitle">
          {{
            selectedGranularity === "day"
              ? "Por día"
              : selectedGranularity === "week"
                ? "Por semana"
                : "Por mes"
          }}
        </span>
      </div>
      <div class="chart-body">
        <app-activity-chart
          [participantTimeline]="participantTimeline"
          [conversationTimeline]="conversationTimeline"
        ></app-activity-chart>
      </div>
    </div>
  </div>

  <!-- Row 3: Top Programs + Campaigns table -->
  <div class="charts-row">
    <div class="chart-card chart-card--half">
      <div class="chart-header">
        <h3><i class="ri-trophy-line"></i> Top Programas por Mensajes</h3>
      </div>
      <div class="chart-body">
        <app-events-table [programData]="programData"></app-events-table>
      </div>
    </div>
    <div class="chart-card chart-card--half">
      <div class="chart-header">
        <h3><i class="ri-megaphone-line"></i> Campañas</h3>
        <p-badge
          [value]="campaignData.length.toString()"
          severity="info"
        ></p-badge>
      </div>
      <div class="chart-body chart-body--table">
        <p-table
          [value]="campaignData"
          [scrollable]="true"
          scrollHeight="300px"
          styleClass="p-datatable-sm p-datatable-striped"
          [rowHover]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Código</th>
              <th>Grupo</th>
              <th>Estado</th>
              <th style="text-align: right">Registros</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-c>
            <tr>
              <td>
                <strong>{{ c.code }}</strong>
              </td>
              <td>{{ c.group }}</td>
              <td>
                <p-tag
                  [value]="c.state === 'A' ? 'Activa' : 'Inactiva'"
                  [severity]="c.state === 'A' ? 'success' : 'danger'"
                ></p-tag>
              </td>
              <td style="text-align: right">
                {{ c.participantCount | number }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" style="text-align: center; padding: 20px">
                Sin datos
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
